import { DateTime } from 'luxon';

export const validateRenewalCadence = ({ renewalPeriod, renewalPeriodUnit }) => {
  const hasPeriod = !!renewalPeriod;
  const hasUnit = !!renewalPeriodUnit;

  if (!hasPeriod && !hasUnit) {
    return { valid: true, renewalPeriod: null, renewalPeriodUnit: null };
  }

  if (hasPeriod && hasUnit && renewalPeriod > 0) {
    return { valid: true, renewalPeriod, renewalPeriodUnit };
  }

  return { valid: false };
};

export const calculateCertificationExpiryDate = ({
  issueDateMs,
  renewalPeriod,
  renewalPeriodUnit,
}) => {
  const { valid, renewalPeriod: period, renewalPeriodUnit: unit } = validateRenewalCadence({
    renewalPeriod,
    renewalPeriodUnit,
  });

  if (!valid || period === null) {
    return null;
  }

  const expiry = DateTime.fromMillis(issueDateMs).plus({ [unit]: period });
  return Math.floor(expiry.toMillis() / 1000);
};

export const formatRenewalCadence = ({ renewalPeriod, renewalPeriodUnit }) => {
  if (!renewalPeriod || !renewalPeriodUnit) {
    return 'Does not expire';
  }

  const unitLabel = renewalPeriod === 1
    ? renewalPeriodUnit.slice(0, -1)
    : renewalPeriodUnit;

  return `${renewalPeriod} ${unitLabel}`;
};
